/* eslint-disable max-len */
import React, { useMemo, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { RootState } from '../../redux/rootState';
// import { deleteSmcStart, getSmcUserStart } from './Redux/sliceSmc';
import DataTable from '../../Common/DataTable';
import { setLoader } from '../../redux/loaderSlice';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
// import { exportToExcelData } from '../../Common/PageHeader/helper';
import { GetInsSummaryResponse, InspectionSummaryData } from './utils/types.d';
import { getInspectionSummaryData } from './redux/sliceInspectionSummary';
import EndPoints from '../../Routes/EndPoints';
import { defaultPageSize } from '../../utils/Constant';

export default function ScreenInspectionSummary() {
  const Navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const dispatch = useDispatch();
  const { jobOrder } = useParams();
  const { isLoading, inspectionSummaryData, totalData } = useSelector((state: RootState) => state.inspectionSummaryReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
      jobOrder: jobOrder || '',
    };
    dispatch(getInspectionSummaryData(params));
  };

  // useEffect(() => {
  //   if (jobOrder) {
  //     setSearchQuery(jobOrder);
  //   } else setSearchQuery('');
  // }, [jobOrder]);
  useEffect(() => {
    if (jobOrder) {
      handleData();
    }
  }, [jobOrder]);

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const columns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'jobOrder', label: 'Job Order #' },
      { key: 'vesselName', label: 'Vessel' },
      { key: 'reportType', label: 'Report Type' },
      { key: 'testType', label: 'TestType' },
      { key: 'defect', label: 'Defect' },
    ],
    [],
  );

  const data: InspectionSummaryData[] = useMemo(() => {
    if (inspectionSummaryData?.length > 0) {
      return inspectionSummaryData?.map((item:GetInsSummaryResponse, index) => {
        const transformedDataItem = {
          sn: index,
          action: 'edit',
          jobOrder: item.JobOrder,
          vesselName: item.VesselName,
          reportType: item.ReportType,
          testType: String(item.TestType),
          defect: item.Defect,
          id: item?.IsNmd ? `${jobOrder}/${item?.VesselId}/edit` : `${item.JobOrder}/${item.SummaryId}/${item?.VesselId}/${encodeURIComponent(item?.DefectCode || 'null')}`,
        };
        return transformedDataItem;
      });
    } if (inspectionSummaryData?.length === 0) {
      const dataItem = {
        sn: 0,
        // action: '',
        action: 'edit',
        jobOrder: jobOrder || '',
        vesselName: '',
        reportType: '',
        testType: '',
        defect: 'NO SIGNIFICANT DEFECTS',
        id: `${jobOrder}/edit`,
      };
      return [dataItem];
    } return [];
  }, [inspectionSummaryData]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleEdit = (id:string) => {
    Navigate(`/${EndPoints.Inspection_Summary}/${id}`);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="Inspection Summary" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <DataTable<InspectionSummaryData>
          data={data}
          columns={columns}
          totalRecords={inspectionSummaryData?.length === 0 ? 1 : totalData}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          searchQuery={searchQuery}
          setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
          sortCol={sortCol}
          setSortCol={(e) => { setSortCol(e); setPage(1); }}
          sortDir={sortDir}
          setSortDir={(e) => { setSortDir(e); setPage(1); }}
          handleData={handleData}
          handleEdit={handleEdit}
          handleDataFromComponent
        />
      </Grid>
    </Grid>
  );
}
